import React, { Component } from 'react'

export default class Breaker extends Component {
    constructor(props) {
        super(props)
        this.change = this.change.bind(this);
    }

    change(event) {
    }

    render() {

        return <div className="dndEditorv2-rightToolsBreaker">
            <div className="dndEditorv2-rightToolsBreaker-line" ></div>
            <div className="dndEditorv2-rightToolsBreaker-title" >{this.props.cat}</div>

        </div >
    }
}